// import SideBar from '../SideBar';
// import Footer from '../Footer';
import '../../styles/resourceStyle.css';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import {listAllNewFeatures} from '../../redux/actions/listAllNewFeatures.js';
import {business, webURL} from "../../config/index.js";
import SideBarSmallScreen from '../SideBarSmallScreen.js';
// import SideBarTest from '../SideBarNew.js';

// Import generic components
import Select from '../../generic_components/Select/Select.jsx';
import Footer from '../../generic_components/Footer/Footer.jsx';

const Videos = () => {
    const isSmallScreen = window.innerWidth < 600;
    const dispatch = useDispatch();
    const listAllFeatures = useSelector(state => state.listAllFeatures); 
    const [selectedVideoTopic, setSelectedVideoTopic] = useState('All');
    const [showLess, setShowLess] = useState(true);
    const initialShownVideos = 8;
    const [countShownVideos, setCountShownVideos] = useState(initialShownVideos); // initally set to 8

    // Filter out the videos based on topics
    let selectedVideoList = (
        selectedVideoTopic === 'All' ? listAllFeatures : listAllFeatures.filter((object) => object.category.toUpperCase() === selectedVideoTopic.toUpperCase())
    );

    // Unique videos in a category
    const setUniqueVideos = new Set();
    selectedVideoList = selectedVideoList.filter((obj) => {
        if (setUniqueVideos.has(obj.url_link)) {
            return false;
        }
        else {
            setUniqueVideos.add(obj.url_link);
            return true;
        }
    });

    // Video list sorted by date. Newest comes first 
    selectedVideoList.sort((a,b) => new Date(b.release_date) - new Date(a.release_date));

    // Show end of results and hide show less when total videos <= initialShownVideos 
    useEffect(() => {
        if (selectedVideoList && selectedVideoList.length <= initialShownVideos){
            setShowLess(false);
        }
    }, [selectedVideoList])

    const shownVideosList = selectedVideoList.slice(0,countShownVideos);

    // Retrieve all the new features from db
    useEffect(()=> {
        dispatch(listAllNewFeatures());
    }, [dispatch]);

    // Convert date to this format e.g. 23 Jan 2025
    const convert_date = (date) => {
        const formatted_date = new Date(date)
            .toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
        return formatted_date;
    }

    // When video topic changes, reset countShownVideos to initialShownVideos
    const handleVideoTopicChange = (event) => {
        setSelectedVideoTopic(event.target.value);
        setCountShownVideos(initialShownVideos);
        setShowLess(true);
    }
    
    // Increment countShownVideos by 4 each time the user clicks the "Show More" button. If the new value exceeds total videos, set it to total number instead
    const handleShowMore = () => {
        setCountShownVideos(prev => Math.min(prev + 4, selectedVideoList.length));
    }

    // Reset countShownVideos to initialShownVideos when user clicks "Show Less" button
    const handleShowLess = () => {
        setCountShownVideos(initialShownVideos);
    }
    
    return (
        <>
            {/* {!isSmallScreen &&  
            <div className='sidebar-container'>
                <SideBar />
            </div>
            } */}
            <div className='video-header-container'>
                <div className='video-header-text'>
                Videos
                </div>
            </div>
            
            <div className='video-component-container'>
                <div className='select-video-container'>
                    <Select
                        className="health-info-dropdown"
                        label="Select a topic"
                        value={selectedVideoTopic}
                        onChange={handleVideoTopicChange}
                        options={[
                                {label: 'All', value: 'All'},
                                {label: 'New Features', value: 'feature'},
                                {label: 'Installation & Setup', value: 'installation'},
                                {label: 'Marketing', value: 'marketing'},
                                ]}
                    />
                </div>

                {/* Render the videos based on topic selected */}
                <div className='videos-container'>
                    {   
                        shownVideosList.map((video) => (
                            <div className='video-title-container'>
                                <iframe
                                    width="100%"
                                    height={isSmallScreen ? "300" : "240"}
                                    src={`${video.url_link}?enablejsapi=1&autoplay=1&vq=hd1080`}
                                    title={video.feature_title}
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                                <div className='feature-title-date'> 
                                    <p className='feature-title'>{video.feature_title}</p>
                                    <p className='release-date'>{business} | {convert_date(video.release_date)}</p>
                                </div>
                            </div>
                        ))
                    }
                </div>
                
                {/* If number of shown videos < length of video list. Display "Show More" button */}
                <div className="show-container">
                    {countShownVideos < selectedVideoList.length ?
                        <button onClick={handleShowMore} className='show-button'><i className="fa-solid fa-angle-down"></i> Show More</button>
                    :
                        <>
                        <p className='eor-message'>End of results</p>
                        {showLess && <button onClick={handleShowLess} className='show-button'><i className="fa-solid fa-angle-up"></i> Show Less</button>}
                        </>
                    }
                </div>
            </div>

            {/* side bar cards for small screens  */}
            {isSmallScreen && <SideBarSmallScreen/>}

            <div className="footer-videos">
            <Footer url={webURL}/> 
            </div>        
        </>
    );
};

export default Videos;